(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5047],{

/***/ 527941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* reexport */ NextImage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(425675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/DesignSystem/NextImage/NextImage.tsx
// import React, { useState } from 'react';
// import Image, { ImageProps } from 'next/image';
// /* --- shimmer helpers --- */
// const toBase64 = (str: string) =>
//   typeof window === 'undefined' ? Buffer.from(str).toString('base64') : window.btoa(str);
// const shimmer = (w = 700, h = 475) => `
// <svg width="${w}" height="${h}" viewBox="0 0 ${w} ${h}" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
//   <defs>
//     <linearGradient id="g">
//       <stop stop-color="#f6f7f8" offset="0%" />
//       <stop stop-color="#eaeaea" offset="50%" />
//       <stop stop-color="#f6f7f8" offset="100%" />
//     </linearGradient>
//   </defs>
//   <rect width="${w}" height="${h}" fill="#f6f7f8"/>
//   <rect id="r" width="${w}" height="${h}" fill="url(#g)">
//     <animateTransform attributeName="transform" attributeType="XML"
//       type="translate" from="-${w} 0" to="${w} 0" dur="1s" repeatCount="indefinite" />
//   </rect>
// </svg>`;
// const shimmerDataURL = (w?: number, h?: number) =>
//   `data:image/svg+xml;base64,${toBase64(shimmer(w ?? 700, h ?? 475))}`;
// /* --- typed props like your original component --- */
// type TNextImage<T extends boolean = false> = T extends true
//   ? { useDefaultHTMLTag: true } & React.ImgHTMLAttributes<HTMLImageElement>
//   : { useDefaultHTMLTag?: false } & ImageProps;
// /* --- main component --- */
// export default function NextImage<T extends boolean = false>(props: TNextImage<T>) {
//   const [normalImageLoaded, setNormalImageLoaded] = useState(false);
//   const [loaded, setLoaded] = useState(false);
//   // native <img> mode
//   if ((props as any).useDefaultHTMLTag) {
//     const {
//       onLoad,
//       style,
//       width = '100%',
//       height = '100%',
//       ...rest
//     } = props as any;
//     const handleLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
//       setNormalImageLoaded(true);
//       if (onLoad) onLoad(e);
//     };
//     // ensure wrapper reserves space; if width/height provided use them, fallback to a default height
//     const wrapperStyle: React.CSSProperties = {
//       display: 'inline-block',
//       position: 'relative',
//       overflow: 'hidden',
//       width: width ? (typeof width === 'number' ? `${width}px` : width) : undefined,
//       height: height ? (typeof height === 'number' ? `${height}px` : height) : undefined,
//       backgroundImage: !normalImageLoaded ? `url("${shimmerDataURL(16, 9)}")` : undefined,
//       backgroundSize: 'cover',
//       backgroundPosition: 'center',
//       ...((style as React.CSSProperties) || {}),
//     };
//     return (
//       <span style={wrapperStyle}>
//         <img
//           {...(rest as React.ImgHTMLAttributes<HTMLImageElement>)}
//           onLoad={handleLoad}
//         />
//       </span>
//     );
//   }
//   // next/image mode
//   const nextProps = props as ImageProps;
//   const { width, height, onLoadingComplete, style } = nextProps as any;
//   // compute small blurDataURL from shimmer (you can also pass a custom blurDataURL prop)
//   const blurData = shimmerDataURL(
//     typeof width === 'number' ? width : 700,
//     typeof height === 'number' ? height : 475
//   );
//   // wrapper ensures a placeholder background while the image is loading
//   const wrapperStyle: React.CSSProperties = {
//     position: nextProps.layout === 'fill' ? 'absolute' : 'relative',
//     display: 'block',
//     width:
//       nextProps.layout === 'fill'
//         ? '100%'
//         : width
//           ? typeof width === 'number'
//             ? `${width}px`
//             : width
//           : undefined,
//     height:
//       nextProps.layout === 'fill'
//         ? '100%'
//         : height
//           ? typeof height === 'number'
//             ? `${height}px`
//             : height
//           : undefined,
//     backgroundImage: !loaded ? `url("${blurData}")` : undefined,
//     backgroundSize: 'cover',
//     backgroundPosition: 'center',
//     ...((style as React.CSSProperties) || {}),
//   };
//   return (
//     <div style={wrapperStyle}>
//       <Image
//         {...nextProps}
//         // keep placeholder prop so Next shows blur if it can, but we also have wrapper background as fallback
//         placeholder="blur"
//         blurDataURL={blurData}
//         onLoadingComplete={(res) => {
//           setLoaded(true);
//           if (onLoadingComplete) onLoadingComplete(res);
//         }}
//       />
//     </div>
//   );
// }





function NextImage(props) {
    if (props.useDefaultHTMLTag) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread/* default */.Z)({}, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        unoptimized: true
    }));
}

;// CONCATENATED MODULE: ./src/components/DesignSystem/NextImage/index.ts



/***/ }),

/***/ 875047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ CardFrameForCollection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(693967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/CardFrameCollection/svgs.tsx



function CardBlobOverlay(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 200 200"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                id: "clip-path",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "transparent",
                    d: "M150.2 63.2c15.7 16.5 29.9 37.4 26.6 55.4-3.2 17.9-24 33-46.6 43.7-22.7 10.8-47.2 17.4-64.8 9.1-17.6-8.3-28.3-31.5-33.7-55.7-5.4-24.1-5.5-49.4 6.8-65.1 12.3-15.7 36.9-21.8 57.8-18.9 20.9 2.9 38.2 15 53.9 31.5z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("image", {
                "clip-path": "url(#clip-path)",
                xlinkHref: props.imageSrc,
                height: "100%",
                width: "100%"
            })
        ]
    }));
}

// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicDesignsUtilities/ContentButtonAnimationStyle.module.scss
var ContentButtonAnimationStyle_module = __webpack_require__(336508);
var ContentButtonAnimationStyle_module_default = /*#__PURE__*/__webpack_require__.n(ContentButtonAnimationStyle_module);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WIdgetPropertiesBasic/components/Button/index.tsx + 1 modules
var Button = __webpack_require__(846976);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicDesignsUtilities/ContentAnimationStyles.module.scss
var ContentAnimationStyles_module = __webpack_require__(489429);
var ContentAnimationStyles_module_default = /*#__PURE__*/__webpack_require__.n(ContentAnimationStyles_module);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/CardFrameCollection/utils.ts
var utils = __webpack_require__(290331);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WidgetProperties/ListPresentation/ListPresentationConfig.tsx
var ListPresentationConfig = __webpack_require__(999719);
// EXTERNAL MODULE: ./node_modules/tailwind-merge/dist/bundle-mjs.mjs
var bundle_mjs = __webpack_require__(798388);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/Carousel/utils.tsx
var Carousel_utils = __webpack_require__(658619);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/btnUtils.js
var btnUtils = __webpack_require__(993080);
// EXTERNAL MODULE: ./src/components/WidgetMaker/utils/buttonConstant.ts
var buttonConstant = __webpack_require__(291850);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(811163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
// EXTERNAL MODULE: ./src/utils/isPLPRequiredSystem.js
var isPLPRequiredSystem = __webpack_require__(586423);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(268037);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/CommonLinkWrapper/index.tsx
var CommonLinkWrapper = __webpack_require__(486353);
// EXTERNAL MODULE: ./src/components/DesignSystem/NextImage/index.ts + 1 modules
var NextImage = __webpack_require__(527941);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/CardFrameCollection/CardFrameCollection.tsx





















function CardFrameForCollection(props) {
    var getRedirectionUrl = function getRedirectionUrl() {
        var ref;
        if (isCategory) {
            var ref1, ref2;
            return (0,routes.getRoute)("".concat((0,isPLPRequiredSystem/* isPLPRequiredSystem */.q)(store === null || store === void 0 ? void 0 : (ref1 = store.theme) === null || ref1 === void 0 ? void 0 : ref1.theme_class) ? routes.PATH.SHOP : routes.PATH.PRODUCT, "?cid=").concat((itemConfig === null || itemConfig === void 0 ? void 0 : itemConfig.id) || 0), store === null || store === void 0 ? void 0 : (ref2 = store.store_info) === null || ref2 === void 0 ? void 0 : ref2.domain);
        }
        return (0,routes.getRoute)(routes.PATH.collectionCategories(itemConfig === null || itemConfig === void 0 ? void 0 : (ref = itemConfig.data) === null || ref === void 0 ? void 0 : ref.id), store === null || store === void 0 ? void 0 : store.domain);
    };
    var handleItemClick = function handleItemClick(e) {
        if (isCategory) {
            var redirectUrl = getRedirectionUrl();
            if (openInNewTab) {
                window.open(redirectUrl, "_blank");
            } else {
                router_default().push(redirectUrl, undefined, {
                    shallow: true
                });
            }
        } else {
            onCollectionClick(itemConfig === null || itemConfig === void 0 ? void 0 : itemConfig.type, itemConfig === null || itemConfig === void 0 ? void 0 : itemConfig.data, e, openInNewTab);
        }
    };
    var ref, ref1, ref2, ref3;
    var oneGridCellGeometry = props.oneGridCellGeometry, cardFrameConfig = props.cardFrameConfig, itemConfig = props.itemConfig, itemIndex = props.itemIndex, openInNewTab = props.openInNewTab, containerTracks = props.containerTracks, isMobile = props.isMobile, customStyle = props.customStyle, onCollectionClick = props.onCollectionClick, contentTypeConditions = props.contentTypeConditions;
    var collectionName = (itemConfig === null || itemConfig === void 0 ? void 0 : (ref = itemConfig.data) === null || ref === void 0 ? void 0 : ref.name) || "";
    var store = (0,redux/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer.store;
    });
    var isCategory = contentTypeConditions === null || contentTypeConditions === void 0 ? void 0 : contentTypeConditions.category;
    var cardShape = cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.cardShape;
    var shouldRenderBlob = false; // cardShape === 'blob';
    // If any element is not textual
    var ref4 = (0,utils/* getCardConfigurations */.JH)(cardFrameConfig), isNonTextualElementPresent = ref4.isNonTextualElementPresent, isButtonLayout = ref4.isButtonLayout, isTextNameBelow = ref4.isTextNameBelow, isCollectionNameVisible = ref4.isCollectionNameVisible;
    // When in mobile layout num of columns is 2
    var mobileExceptions = {
        oneColumn: isMobile && containerTracks.numColumns === 1,
        twoColumn: isMobile && containerTracks.numColumns === 2
    };
    var shapeStyleCalculated = (0,utils/* getShapeStyles */.cw)(cardShape, oneGridCellGeometry.width);
    var shapeStyle = shapeStyleCalculated[itemIndex % (shapeStyleCalculated === null || shapeStyleCalculated === void 0 ? void 0 : shapeStyleCalculated.length)];
    var overlayWrapperStyles = (0,utils/* getOverlayWrapperStyles */.bR)(cardFrameConfig, isTextNameBelow);
    var onButtonClick = function(e, btnData) {
        var ref;
        if (btnData === null || btnData === void 0 ? void 0 : (ref = btnData.actions) === null || ref === void 0 ? void 0 : ref.type) (0,btnUtils/* btnActionHandler */.c)(btnData === null || btnData === void 0 ? void 0 : btnData.actions, function() {});
        else handleItemClick(e);
    };
    var _RenderCollectionName = function() {
        var ref, ref1, ref2;
        return cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : (ref = cardFrameConfig.contentConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.textConfig) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.appearanceButton) === null || ref2 === void 0 ? void 0 : ref2.map(function(buttonData, btnIndex) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6;
            var overlayButtonStyles = (0,utils/* getTextContainerStyles */.wo)(cardFrameConfig);
            var overlayTextStyles = (0,utils/* getOverlayTextStyles */.z4)(cardFrameConfig, buttonData);
            var buttonVariant = (0,Carousel_utils/* getButtonVariantsData */.Tk)(buttonData, false);
            var selectedButtonType = buttonVariant[buttonData.type];
            var doesNameContainsSpace = (collectionName === null || collectionName === void 0 ? void 0 : collectionName.indexOf(" ")) >= 0;
            var isBtnSolid = buttonData.type === buttonConstant/* BUTTON_TYPE.SOLID */.JB.SOLID;
            var isUnderlineAnimation = (ref2 = buttonData === null || buttonData === void 0 ? void 0 : (ref = buttonData.buttonAnimationConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.classKey) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === null || ref2 === void 0 ? void 0 : ref2.includes("underline");
            return buttonData.isShow ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                size: cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : (ref3 = cardFrameConfig.contentConfig) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.textConfig) === null || ref4 === void 0 ? void 0 : ref4.textSize,
                btnType: buttonData.type,
                buttonData: buttonData,
                selectedButtonData: selectedButtonType,
                variant: selectedButtonType.variant,
                onClick: function(e) {
                    return onButtonClick(e, buttonData);
                },
                className: (0,bundle_mjs/* twMerge */.m6)("tw-pointer-events-auto !tw-max-w-[100%] !tw-whitespace-nowrap !tw-rounded-none !tw-font-normal", (buttonData === null || buttonData === void 0 ? void 0 : buttonData.type) === "textual" ? "!tw-w-max" : "!tw-w-[100%] !tw-px-[10px] !tw-py-[10px]", isBtnSolid ? " !tw-border-none" : "", overlayButtonStyles.className, !(buttonData === null || buttonData === void 0 ? void 0 : (ref5 = buttonData.buttonAnimationConfig) === null || ref5 === void 0 ? void 0 : ref5.classKey) ? "[&_p]:before:!tw-hidden" : (ContentButtonAnimationStyle_module_default())[buttonData === null || buttonData === void 0 ? void 0 : (ref6 = buttonData.buttonAnimationConfig) === null || ref6 === void 0 ? void 0 : ref6.classKey]),
                textWrapperClass: isUnderlineAnimation && "!tw-mx-0 !tw-mb-[2.2px] !tw-mt-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("tw-m-0 tw-line-clamp-2 tw-max-w-[100%] tw-text-ellipsis tw-whitespace-break-spaces", doesNameContainsSpace ? "tw-break-words" : "tw-break-all"),
                    style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, overlayTextStyles), {
                        lineHeight: 1.2
                    }),
                    children: collectionName
                })
            }, btnIndex) : null;
        });
    };
    var _RenderButton = function() {
        var ref, ref1, ref2;
        return (ref2 = cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : (ref = cardFrameConfig.contentConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonConfig) === null || ref1 === void 0 ? void 0 : ref1.filter(function(btn) {
            return btn.isShow;
        })) === null || ref2 === void 0 ? void 0 : ref2.map(function(buttonData, btnIndex) {
            var ref, ref1;
            var overlayTextStyles = (0,utils/* getOverlayTextStyles */.z4)(cardFrameConfig, buttonData);
            var buttonVariant = (0,Carousel_utils/* getButtonVariantsData */.Tk)(buttonData, false);
            var selectedButtonType = buttonVariant[buttonData.type];
            var isBtnSolid = buttonData.type === buttonConstant/* BUTTON_TYPE.SOLID */.JB.SOLID;
            return buttonData.isShow ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                // size={cardFrameConfig?.contentConfig?.textConfig?.textSize}
                btnType: buttonData.type,
                buttonData: buttonData,
                selectedButtonData: selectedButtonType,
                variant: selectedButtonType.variant,
                onClick: function(e) {
                    return handleItemClick(e);
                },
                className: (0,bundle_mjs/* twMerge */.m6)("tw-pointer-events-auto !tw-w-min !tw-max-w-[100%] !tw-whitespace-nowrap !tw-rounded-none !tw-font-normal", mobileExceptions.twoColumn ? "!tw-mt-[12px]" : "!tw-mt-[16px]", !(buttonData === null || buttonData === void 0 ? void 0 : (ref = buttonData.buttonAnimationConfig) === null || ref === void 0 ? void 0 : ref.classKey) ? "[&_p]:before:!tw-hidden" : (ContentButtonAnimationStyle_module_default())[buttonData === null || buttonData === void 0 ? void 0 : (ref1 = buttonData.buttonAnimationConfig) === null || ref1 === void 0 ? void 0 : ref1.classKey], isBtnSolid ? " !tw-border-none " : "", (buttonData === null || buttonData === void 0 ? void 0 : buttonData.type) !== "textual" ? "!tw-px-[10px] !tw-py-[10px]" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("tw-m-0 tw-font-medium", mobileExceptions.twoColumn ? "!tw-text-[12px]" : "!tw-text-[14px]"),
                    style: overlayTextStyles || {},
                    children: buttonData === null || buttonData === void 0 ? void 0 : buttonData.text
                })
            }, btnIndex) : null;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonLinkWrapper/* default */.Z, {
        link: !openInNewTab ? getRedirectionUrl() : "",
        disableLink: openInNewTab,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-flex tw-cursor-pointer tw-select-none tw-flex-col tw-items-center tw-max-w-full",
            style: customStyle || {},
            onClick: function(e) {
                return handleItemClick(e);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("tw-relative tw-flex-shrink-0 tw-overflow-hidden", shapeStyle.className),
                    style: (0,_object_spread/* default */.Z)({
                        width: "".concat(oneGridCellGeometry.width, "px"),
                        height: "".concat(oneGridCellGeometry.height, "px")
                    }, shapeStyle.style || {}),
                    children: [
                        !shouldRenderBlob ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* NextImage */.o, {
                            src: (itemConfig === null || itemConfig === void 0 ? void 0 : (ref1 = itemConfig.data) === null || ref1 === void 0 ? void 0 : ref1.image_url) || ListPresentationConfig.DEFAULT_COLLECTION_CARD_IMAGE,
                            className: classnames_default()("tw-absolute tw-h-[100%] tw-w-[100%] tw-object-cover tw-transition-all tw-duration-500", (ContentAnimationStyles_module_default())[(0,utils/* getCurrentClass */.WR)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.hoverEffect)], shapeStyle.className),
                            loading: "lazy",
                            decoding: "async",
                            layout: "fill",
                            quality: isMobile ? 75 : 100,
                            style: shapeStyle.style || {}
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CardBlobOverlay, {
                            className: "tw-absolute tw-inset-0 tw-h-[100%] tw-w-[100%]",
                            imageSrc: (itemConfig === null || itemConfig === void 0 ? void 0 : (ref2 = itemConfig.data) === null || ref2 === void 0 ? void 0 : ref2.image_url) || ListPresentationConfig.DEFAULT_COLLECTION_CARD_IMAGE,
                            width: oneGridCellGeometry.width
                        }),
                        (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : (ref3 = cardFrameConfig.contentConfig) === null || ref3 === void 0 ? void 0 : ref3.textConfig.type) === "overlay" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()("shadowOverlay imgWrapperGlobalStyle globalImgStyleConsumer tw-pointer-events-none tw-absolute tw-inset-0 tw-flex tw-flex-col ", shapeStyle.className, mobileExceptions.twoColumn && isButtonLayout ? "tw-p-[10px]" : isButtonLayout ? "tw-p-[16px]" : isNonTextualElementPresent ? "tw-p-[12px]" : "tw-p-[20px]"),
                            style: (0,_object_spread/* default */.Z)({}, overlayWrapperStyles),
                            children: [
                                _RenderCollectionName(),
                                _RenderButton()
                            ]
                        })
                    ]
                }),
                isTextNameBelow && isCollectionNameVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-mt-[16px] tw-flex tw-w-[100%] tw-flex-col",
                    style: overlayWrapperStyles,
                    children: _RenderCollectionName()
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/CardFrameCollection/index.tsx



/***/ }),

/***/ 336508:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"widgetContentFadeInWrapper":"ContentButtonAnimationStyle_widgetContentFadeInWrapper__gzPMJ","fadeIn":"ContentButtonAnimationStyle_fadeIn__Mx5Ue","widgetContentFadeInZoomInWrapper":"ContentButtonAnimationStyle_widgetContentFadeInZoomInWrapper__9exDB","fadeInZoomIn":"ContentButtonAnimationStyle_fadeInZoomIn__FGJ6r","widgetContentMoveDownWrapper":"ContentButtonAnimationStyle_widgetContentMoveDownWrapper__EWZJt","moveDown":"ContentButtonAnimationStyle_moveDown__HotCW","builderSelectorDemo":"ContentButtonAnimationStyle_builderSelectorDemo__P7Dit","demoMoveDown":"ContentButtonAnimationStyle_demoMoveDown__VsgIP","widgetContentMoveUpWrapper":"ContentButtonAnimationStyle_widgetContentMoveUpWrapper__q4jnq","moveUp":"ContentButtonAnimationStyle_moveUp__JqBuF","demoMoveUp":"ContentButtonAnimationStyle_demoMoveUp__f_z3_","widgetContentSlideLeftWrapper":"ContentButtonAnimationStyle_widgetContentSlideLeftWrapper__C_WGJ","moveLeft":"ContentButtonAnimationStyle_moveLeft__wtumW","demoMoveLeft":"ContentButtonAnimationStyle_demoMoveLeft__XAysw","widgetContentSlideRightWrapper":"ContentButtonAnimationStyle_widgetContentSlideRightWrapper__Ael_0","moveRight":"ContentButtonAnimationStyle_moveRight__NWc9p","demoMoveRight":"ContentButtonAnimationStyle_demoMoveRight__kmTdf","imageZoomIn":"ContentButtonAnimationStyle_imageZoomIn__zXH0u","imageZoomOut":"ContentButtonAnimationStyle_imageZoomOut__ywFAu","zoomInOnHover":"ContentButtonAnimationStyle_zoomInOnHover__wpSXv","ambient":"ContentButtonAnimationStyle_ambient__lq2Vz","animationAmbient":"ContentButtonAnimationStyle_animationAmbient__Mp7Dt"};

/***/ })

}]);